exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-row[data-v-3f7410dc]{display:grid;grid-template-columns:32px auto 100px}.total-row[data-v-3f7410dc]{display:grid;grid-template-columns:auto 100px}.has-error[data-v-3f7410dc] .booking-widget-input,.has-error[data-v-3f7410dc] .guest-picker input{border-color:red}", ""]);

// exports
